import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import {enGBFnsLocale} from "../utils/dateTimeUtils";
import { isInAllowedKeys } from "../utils/miscUtils";
import DateOnlyInput from "./DateOnlyInput";

function CalendarPicker(props) {
    const [selectedDate, setSelectedDate] = useState(null);
    const [open, setOpen] = useState(false);

    const inputRef = useRef();

    const handleChange = (date) => {
        inputRef.current.focus();
        props.onChange(date);
        setSelectedDate(date);
        setOpen(false);
    };

    return (
        <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={selectedDate}
            onChange={handleChange}
            className={props.className}
            minDate={props.minDate}
            maxDate={props.maxDate}
            placeholderText="Select a date"
            showMonthYearDropdown
            popperPlacement="bottom-start"
            onKeyDown={(e)=>{
                if(!isInAllowedKeys(e.key)) e.preventDefault();
            }}
            autoComplete="off"
            locale={enGBFnsLocale}
            customInput={<DateOnlyInput inputRef={inputRef} openOnFocus={() => setOpen(true)} /> }
            open={open}
            onClickOutside={()=> setOpen(false)}
        />
    );
}

export default CalendarPicker;